<template>
  <div class="shopinfo-box">
    <a-card :bordered="false">
      <div class="shopinfo-content">
        <div class="head-opera-box">
          <a-button class="editable-add-btn" @click="addOne">添加</a-button>
        </div>
        <a-table
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: haoSelect
          }"
          :columns="columns"
          :dataSource="menuList"
          :pagination="false"
          :rowKey="menuList => menuList.id"
        >
          <div slot="action" slot-scope="record" class="opera-btn-box">
            <a-button
              type="primary"
              size="small"
              href="javascript:;"
              @click="changeInfo(record)"
              >修改</a-button
            >
            <a-popconfirm
              :title="'你确定要删除菜单：' + record.name + '吗?'"
              okText="删除"
              cancelText="取消"
              @confirm="deleteOne(record)"
            >
              <a-button type="primary" size="small" href="javascript:;"
                >删除</a-button
              >
            </a-popconfirm>
          </div>
        </a-table>
        <a-modal
          :title="title"
          :visible="visible"
          @ok="handleOk"
          :confirmLoading="confirmLoading"
          @cancel="handleCancel"
        >
          <a-form>
            <a-form-item
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
              label="Id"
            >
              <a-input placeholder="请输入Id" v-model="item.id" />
            </a-form-item>
            <a-form-item
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
              label="名称"
            >
              <a-input placeholder="请输入名称" v-model="item.name" />
            </a-form-item>
            <a-form-item
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
              label="排序"
            >
              <a-input placeholder="请输入排序" v-model="item.sort" />
            </a-form-item>
            <a-form-item
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
              label="路径"
            >
              <a-input placeholder="请输入路径" v-model="item.url" />
            </a-form-item>
            <a-form-item
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
              label="父Id"
            >
              <a-input placeholder="请输入父Id" v-model="item.pid" />
            </a-form-item>
          </a-form>
        </a-modal>
      </div>
    </a-card>
  </div>
</template>

<script>
import { SETTING_query, SETTING_update } from "@/api/setting";
import "@/utils/directive";
const columns = [
  {
    title: "ID",
    dataIndex: "id"
  },
  {
    title: "名称",
    dataIndex: "name"
  },
  {
    title: "排序",
    dataIndex: "sort"
  },
  {
    title: "路径",
    dataIndex: "url"
  },
  {
    title: "父ID",
    dataIndex: "pid"
  },
  {
    title: "操作",
    key: "operation",
    scopedSlots: { customRender: "action" },
    align: "center"
  }
];
export default {
  data() {
    return {
      siteInfo: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      columns,
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      menuList: [],
      selectedRowKeys: [],
      visible: false,
      confirmLoading: false,
      title: "添加",
      item: {
        id: "",
        name: "",
        sort: "",
        url: "",
        pid: ""
      }
    };
  },
  created() {},
  mounted() {
    this.getInfo();
  },
  methods: {
    getInfo: function() {
      SETTING_query({ type: "articletype" })
        .then(response => {
          this.menuList = response.res;
        })
        .catch(() => {});
    },
    setInfo: function(_obj) {
      SETTING_update({
        type: "articletype",
        info: _obj
      })
        .then(response => {
          console.log(response.res);
          if (response.status === 0) {
            this.$notification.success({
              message: "提示",
              description: response.res
            });
          } else {
            this.$notification.success({
              message: "提示",
              description: response.res
            });
          }
        })
        .catch(() => {});
    },
    haoSelect: function(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    changeInfo: function(_data) {
      console.log(_data);
      this.item = _data;
      this.visible = true;
    },
    deleteOne: function(_data) {
      let _ind = "";
      this.menuList.forEach(function(item, index) {
        if (item.id === _data.id) {
          _ind = index;
        }
      });
      this.menuList.splice(_ind, 1);
      this.setInfo(this.menuList);
      console.log(this.menuList);
    },
    addOne: function() {
      console.log("_data");
      this.item = {};
      this.visible = true;
    },
    handleOk: function() {
      this.menuList.push(this.item);
      console.log(this.menuList);
      this.setInfo(this.menuList);
      this.getInfo();
      console.log("handleOk");
    },
    handleCancel: function() {
      console.log("handleCancel");
      this.visible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.shopinfo-content {
  .ant-form-item {
    margin-bottom: 10px;
  }
  .head-opera-box {
    margin-bottom: 10px;
  }
  .btn-list {
    margin-top: 30px;
  }
  form textarea.ant-input {
    min-height: 500px;
  }
  .opera-btn-box a {
    margin: 0 5px;
  }
}
</style>
